module.exports = __webpack_public_path__ + "img/feature_buy_en.9a980d4a.png";